import { COMMAND_BLOCK, DOMAIN_TYPE_CHAT_MESSAGE_COMMAND } from "../../../consts";
export var getThreadMessageCommands = function (state) {
    return Object.values(state.domain[DOMAIN_TYPE_CHAT_MESSAGE_COMMAND] || {});
};
/**
 * Get all block commands, we are not interested in particular thread, because we block user for any thread
 */
export var getThreadMessageBlockCommands = function (state) {
    var allCommands = getThreadMessageCommands(state);
    return allCommands.filter(function (m) { return m.meta.commandName === COMMAND_BLOCK; });
};
export var getLastBlockCommandMessage = function (state) {
    var messages = getThreadMessageBlockCommands(state);
    if (messages.length === 0) {
        return undefined;
    }
    else if (messages.length === 1) {
        return messages[0];
    }
    // sort by timestamp - oldest to newest
    var sorted = messages.sort(function (a, b) { return a.timestamp - b.timestamp; });
    return sorted[sorted.length - 1];
};
